<template>
  <section class="block-stock stock">
    <div class="container">
      <h2 class="stock__title">
        Автомобили в наличии<br v-if="device_platform !== 'desktop'" />
        <span>- {{ modelsCount }}</span>
      </h2>
      <div class="stock__filters">
        <drop-down-select
          class="stock__filter"
          title="Модель"
          :cur_value="model_filter"
          :options="models_list"
          @change="changeModel"
        ></drop-down-select>
        <drop-down-select
          class="stock__filter"
          title="Двигатель"
          :cur_value="engine_filter"
          :options="available_engines"
          @change="changeEngine"
        ></drop-down-select>
        <drop-down-select
          class="stock__filter"
          title="Комплектация"
          :cur_value="comp_filter"
          :options="available_comps"
          @change="changeComp"
        ></drop-down-select>
      </div>
    </div>
    <div class="container list">
      <div class="stock__list">
        <div class="model" v-for="model in models_to_show" :key="model.vin">
          <div class="model__gallery">
            <div class="model__img-wrapper">
              <img
                :src="model.img"
                :alt="model.name"
                :class="'model__img ' + model.vin"
              />
            </div>
          </div>

          <div class="model__info">
            <h3 class="model__name">{{ model.name }}</h3>
            <div class="model__info-container">
              <ul class="model__specs">
                <li class="model__spec">
                  <p>Модификация:</p>
                  <p>{{ model.modification }}</p>
                </li>
                <li class="model__spec">
                  <p>Тип кузова:</p>
                  <p>{{ model.body_type }}</p>
                </li>
                <li class="model__spec">
                  <p>КПП:</p>
                  <p>{{ model.transmission }}</p>
                </li>
                <li class="model__spec">
                  <p>Год выпуска:</p>
                  <p>{{ model.year }}</p>
                </li>
              </ul>
              <div class="model__actions">
                <v-phone :raw="CONSTANTS.phone_raw" class="header__phone">
                  {{ CONSTANTS.phone }}
                </v-phone>
                <button
                  class="model__btn button button_theme_black"
                  @click="
                    getCall({
                      type: 'sale',
                      form: 'stock',
                      title: 'Узнать цену',
                    })
                  "
                >
                  <span>Узнать цену</span>
                </button>
                <button
                  class="model__btn button button_theme_white"
                  @click="
                    getCall({
                      type: 'sale',
                      form: 'stock',
                      title: 'Записаться на тест-драйв',
                    })
                  "
                >
                  <span>Записаться на тест-драйв</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="stock__more-btn" v-if="show_more_btn" @click="showMore">
        Показать еще
      </button>
    </div>
  </section>
</template>

<script>
import DropDownSelect from "./drop-down-select";
import VPhone from "./v-phone.vue";

import CARS_DATA from "../common/data-placeholder";
import Mixin from "../common/mixin";
import finance from "../common/finance";
import axios from "axios";
import CarsInfo from "../common/cars-info";

export default {
  name: "block-stock",
  props: ["selected_model"],
  mixins: [finance, Mixin],
  components: { DropDownSelect, VPhone },
  data() {
    return {
      model_filter: "Все",
      comp_filter: "",
      engine_filter: "",
      models_per_view: 4,
      cars_data: [],
    };
  },
  mounted() {
    // Dev mode
    // this.cars_data = CARS_DATA;

    axios.get("./back/cars", {}).then((res) => {
      console.log(res);
      this.cars_data = (res && res.data) || [];
    });

    // this.cars_data = this.cars_data.filter(car => {
    //   const car_name = car.model.split(',')[0];
    //   return stock_filter.includes(car_name);
    // });

    // axios.get("./back/cars", {}).then((res) => {
    //   console.log(res);
    //   this.cars_data = (res && res.data) || [];

    //   this.cars_data = this.cars_data.filter(car => {
    //     const car_name = car.model.split(',')[0];
    //     return stock_filter.includes(car_name);
    //   });

    //   this.cars_data = this.cars_data.map((car) => {
    //     const regex = /\b[a-zA-Z0-9_\-]+\s?/;
    //     const short_name = car.model.match(regex).join("").trim();
    //     let full_name = short_name;
    //     ["Sedan", "Allroad", "Coupe", "Sportback"].forEach((str) => {
    //       if (car.model.includes(str)) {
    //         full_name = `${short_name} ${str}`;
    //       }
    //     });
    //     if(car.model === "RS Q8") {
    //       full_name = car.model;
    //     }
    //     return {
    //       ...car,
    //       name: full_name,
    //     };
    //   });
    // });
  },
  watch: {
    selected_model() {
      const model = this.models_list.find((model) =>
        model.includes(this.selected_model)
      );
      if (model) {
        this.model_filter = model;
      }
    },
  },
  computed: {
    models_list() {
      const set = new Set();
      this.cars_data.forEach((car) => {
        set.add(car.model);
      });

      const models = Array.from(set).filter(model => model !== "e-tron").sort();
      models.unshift("Все");
      return models;
    },
    prefiltered_models() {
      if (this.model_filter === "Все") {
        return this.cars_data.filter((car) => car.model !== 'e-tron');
      }
      return this.cars_data.filter((car) => car.model === this.model_filter);
    },
    available_engines() {
      let ret = [];
      let ret_cars = this.prefiltered_models;

      if (this.comp_filter.length > 0) {
        ret_cars = ret_cars.filter(
          (car) => car.complectation === this.comp_filter
        );
      }

      ret_cars.forEach((car) => {
        if (!ret.includes(car.modification)) {
          ret.push(car.modification);
        }
      });
      return ret;
    },
    available_comps() {
      let ret = [];
      let ret_cars = this.prefiltered_models;

      if (this.engine_filter !== "") {
        ret_cars = ret_cars.filter(
          (car) => car.modification === this.engine_filter
        );
      }

      ret_cars.forEach((car) => {
        if (!ret.includes(car.complectation)) {
          ret.push(car.complectation);
        }
      });
      return ret;
    },
    filtered_models() {
      let ret_cars = this.prefiltered_models;

      if (this.comp_filter.length > 0) {
        ret_cars = ret_cars.filter(
          (car) => car.complectation === this.comp_filter
        );
      }
      if (
        typeof this.engine_filter === "number" ||
        this.engine_filter.length > 0
      ) {
        ret_cars = ret_cars.filter(
          (car) => car.modification === this.engine_filter
        );
      }

      return ret_cars;
    },
    models_to_show() {
      return this.filtered_models.slice(0, this.models_per_view);
    },
    show_more_btn() {
      return this.filtered_models.length > this.models_per_view;
    },
    modelsCount() {
      if (this.filtered_models.length === 1) {
        return `${this.filtered_models.length} автомобиль`;
      } else if (this.filtered_models.length < 5) {
        return `${this.filtered_models.length} автомобиля`;
      } else {
        return `${this.filtered_models.length} автомобилей`;
      }
    },
  },
  methods: {
    changeModel(model) {
      this.models_per_view = 4;
      this.engine_filter = "";
      this.comp_filter = "";
      this.model_filter = model;
    },
    changeEngine(engine) {
      this.models_per_view = 4;
      this.engine_filter = engine;
    },
    changeComp(comp) {
      this.models_per_view = 4;
      this.comp_filter = comp;
    },
    getModelImg(imgs) {
      if (Array.isArray(imgs)) {
        return imgs.slice(0, 4);
      } else {
        return [imgs];
      }
    },
    showPagination(imgs) {
      if (Array.isArray(imgs)) {
        return imgs.length > 1;
      } else {
        return false;
      }
    },
    getRawPhone(phone) {
      return phone.replace(/\D+/g, "");
    },
    showMore() {
      this.models_per_view += 4;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.stock {
  padding: 100px 0 60px 0;

  &__title {
    font-family: "AudiTypeExt", sans-serif;
    font-size: 30px;

    span {
      font-size: 18px;
      font-weight: normal;
      color: $red;
      padding-left: 29px;
    }
  }

  &__filters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 0;
  }

  &__filter {
    max-width: 300px;
  }

  &__more-btn {
    display: block;
    font-family: "AudiType", sans-serif;
    background-color: transparent;
    font-size: 14px;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    margin: 0 auto;
  }
}

.model {
  display: flex;
  align-items: center;
  margin-bottom: 48px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);

  &__gallery {
    width: 400px;
    height: 250px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__img {
    max-width: 100%;
  }

  &__info {
    flex: 1;
    padding: 21px 30px;
  }

  &__name {
    font-size: 18px;
    margin-bottom: 15px;
  }

  &__info-container {
    display: flex;
    align-items: flex-start;
  }

  &__specs {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
  }

  &__spec {
    width: 50%;
    margin-bottom: 24px;
    padding-right: 5px;
    p {
      font-size: 14px;
      font-weight: bold;
      color: #333333;

      &:first-child {
        font-size: 13px;
        font-weight: normal;
        margin-bottom: 8px;
      }
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__btn {
    margin-top: 20px;
  }

  &__phone {
    font-size: 16px;
  }
}

@media (max-width: 1200px) {
  .stock {
    padding: 60px 0 60px 0;
    .container {
      &.list {
        padding: 0;
      }
    }

    &__title {
      span {
        padding-left: 0;
      }
    }

    &__filters {
      flex-direction: column;
    }

    &__filter {
      max-width: 500px;

      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }
  .model {
    max-width: 500px;
    margin: 0 auto;
    margin-bottom: 40px;
    flex-direction: column;

    &__gallery {
      width: 100%;
      height: unset;
    }

    &__info {
      width: 100%;
      padding: 20px;
    }

    &__info-container {
      flex-direction: column;
    }

    &__actions {
      width: 100%;
    }

    &__btn {
      width: 100%;
    }
  }
}
</style>
